<template>
  <div class="tableDiv" :style="{'height':(options.tableHeight+'px')}">
    <el-table
      :data="list"
      border
      :stripe="options.stripe"
      fit
      style="width: 100%"
      :max-height="options.tableHeight"
      @selection-change="handleSelectionChange"
    >
      <!-- 暂无数据提示，自己定义就OK了 -->
      <template slot="empty">
        <div class="empty-box mt20 mb20">
          <i class="mh-kym_icon icon"></i>
          <p class="col-66 text-1 mt10" v-if="options.errortip">{{options.errortip}}</p>
          <p class="col-66 text-1 mt10" v-else>{{$t('Common.empty_tips')}}</p>
        </div>
      </template>
      <!--region 选择框-->
      <el-table-column
        v-if="options.RadioSelect"
        style="width: 30px;"
        min-width="30px"
        fixed="left"
      >
        <template slot-scope="scope">
          <el-radio
            v-model="radio"
            :label="scope.$index"
            @change="singleBox(scope.row,scope.$index)"
          ></el-radio>
        </template>
      </el-table-column>
      <!--region 选择框-->
      <el-table-column v-if="options.mutiSelect" type="selection" style="width: 55px;"></el-table-column>
      <!-- <el-table-column v-if="!options.mutiSelect" type="selection" :selectable='checkboxInit' toggleRowSelection="selected" style="width: 55px;"></el-table-column> -->
      <!--endregion-->
      <!-- 编辑列start -->
      <template v-for="(column,$index) in columns">
        <template v-if="column.isfixed">
          <el-table-column
            :prop="column.fieldname"
            :key="$index"
            fixed="left"
            :label="column.fieldstring"
            align="center"
            :sortable="column.sortable"
            min-width="150px"
            :show-overflow-tooltip="true"
            v-if="column.show=='1'"
          ></el-table-column>
        </template>
        <template v-else-if="$index==IndexId || $index==IndexIdTwo">
          <el-table-column
            :prop="column.fieldname"
            :key="$index"
            fixed="left"
            :label="column.fieldstring"
            align="center"
            :sortable="column.sortable"
            min-width="150px"
            :show-overflow-tooltip="true"
            v-if="column.show=='1'"
          ></el-table-column>
        </template>
        <template v-else>
          <el-table-column
            :prop="column.fieldname"
            :key="$index"
            :label="column.fieldstring"
            align="center"
            :sortable="column.sortable"
            min-width="150px"
            :show-overflow-tooltip="true"
            v-if="column.show=='1'"
          ></el-table-column>
        </template>
      </template>
      <!-- 编辑列end -->
      <!--region 按钮操作组-->
      <el-table-column
        ref="fixedColumn"
        min-width="150px"
        :label="operates.label"
        :align="operates.align"
        :width="operates.width"
        :fixed="operates.fixed"
        v-if="operates.list.filter(_x=>_x.show === true).length > 0"
      >
        <template slot-scope="scope">
          <template v-for="(btn, key) in operates.list">
            <template v-if="btn.show">
              <el-button
                @click.native.prevent="btn.method(key,scope.row)"
                :type="btn.type"
                size="small"
                :key="btn.id"
                :disabled="btn.disabled"
              >{{ btn.label }}</el-button>
            </template>
          </template>
        </template>
      </el-table-column>

      <el-table-column
        v-if="issetting"
        :fixed="tableOperate.fixed"
        :label="tableOperate.fieldstring"
        :align="tableOperate.align"
        width="40px"
        :render-header="renderHeader"
      >
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: "totalTbale",
  props: {
    radioValue: null,
    total: Number, //分页数据
    pagesize: Number, //分页条数
    issetting: null, //是否可编辑列
    list: {
      type: Array
      // default: []
    }, // 数据列表
    isCheckbox: null,
    isPagination: null,
    columns: {
      type: Array
      // default: []
    }, // 需要展示的列 === prop：列数据对应的属性，label：列名，align：对齐方式，width：列宽
    operates: {}, // 操作按钮组 === label: 文本，type :类型（primary / success / warning / danger / info / text），show：是否显示，icon：按钮图标，plain：是否朴素按钮，disabled：是否禁用，method：回调方法
    options: {
      type: Object
      // default: {
      //   highlightCurrentRow: false // 是否要高亮当前行
      // }
    }, // table 表格的控制参数
    tableOperate: {
      type: Object
    }
  },
  data() {
    return {
      currentPage: 1,
      num: 10,
      size: 10,
      radio: "",
      dropdownInfo: [
        {
          id: "0",
          label: "补费"
        },
        {
          id: "1",
          label: "结转"
        },
        {
          id: "2",
          label: "退费"
        },
        {
          id: "3",
          label: "编班"
        },
        {
          id: "4",
          label: "转班"
        },
        {
          id: "5",
          label: "转校"
        },
        {
          id: "6",
          label: "跨校"
        },
        {
          id: "7",
          label: "延班"
        },
        {
          id: "8",
          label: "无意向"
        }
      ],
      IndexId: -1, //固定的列数
      IndexIdTwo: -1 //固定的列数
    };
  },
  created() {
    
    this.num = this.total;
    this.size = this.pagesize;

    this.radio = this.radioValue;
    this.getColums();
  },
  watch: {
    total(newdata, olddata) {
      (() => {})(newdata, olddata);
      this.num = this.newdata;
    },
    pagesize(newdata, olddata) {
      (() => {})(newdata, olddata);
      this.size = this.newdata;
    },
    radioValue(n, o) {
      if (!n) {
        this.radio = "";
      }
    },
    getIndex(n, o) {
      (() => {})(n);
      var i = 0;
      var _index = 0,
        _index_two = 0;
      if (n.length >= 8) {
        n.forEach((item, index) => {
          if (item.show == "1" && i == 0) {
            i++;
            _index = index;
          } else if (item.show == "1" && i == 1) {
            i++;
            _index_two = index;
          }
        });
        this.IndexId = _index;
        this.IndexIdTwo = _index_two;
      }
      (() => {})(this.IndexId);
    }
  },
  computed: {
    getIndex() {
      return this.columns;
    }
  },
  methods: {
    getColums() {
      var i = 0;
      var _index = 0,
        _index_two = 0;
      if (this.columns.length >= 8) {
        this.columns.forEach((item, index) => {
          if (item.show == "1" && i == 0) {
            i++;
            _index = index;
          } else if (item.show == "1" && i == 1) {
            i++;
            _index_two = index;
          }
        });
        this.IndexId = _index;
        this.IndexIdTwo = _index_two;
      }
    },
    singleBox(val, index) {
      this.$emit("singleBox", val, index);
    },
    renderHeader(h, { column, $index }) {
      (() => {})(h, column, $index);
      return h("span", {
        class: "el-icon-setting btn-setting",
        on: {
          click: () => {
            (() => {})(`${column.fieldstring}----${$index}`);
            this.$emit("toggleEditableColumn");
          }
        }
      });
    },
    checkboxInit(row, index) {
      return 0; //不可勾选
      // 　　if (row.withdrawState==2)//这个判断根据你的情况而定
      // 　　　　return 0;//不可勾选
      // 　　else
      // 　　　　return 1;//可勾选
      // 　　},
    },
    handleSelectionChange(val) {
      // this.multipleSelection = val;
      this.$emit("handleSelectionChange", val);
    },
    handleColumnChange(k, v) {
      this.$emit("handleColumnChange", k, v);
    },
    handleCodeChange(k, v) {
      (() => {})(k, v);
      this.$emit("handleCodeChange", k, v);
    },
    // 分页
    // handleSizeChange(val) {
    //   (() => {})(`每页 ${val} 条`);
    //   (() => {})(this.total.dataNumber);
    // },
    // handleCurrentChange(val) {
    //   (() => {})(`当前页: ${val}`);
    // }
    handleCommand(command) {
      (() => {})(command);
      this.$emit("showdialog", command);
    }
  }
};
</script>
<style lang="less">
.item {
  display: inline-block;
}
.item + .item {
  margin-left: 15px !important;
}
.table-code {
  width: 40px;
  margin: 0 auto;
  img {
    width: 100%;
  }
}
.tableDiv {
  margin-bottom: 20px;
}
.btn-setting {
  display: block;
  width: 20px;
  height: 20px;
  font-size: 18px;
  margin: 0 auto;
  color: #aaa;
  // background-color: green;
  cursor: pointer;
}

.progress-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .progress-box--inner {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333;
    .el-progress-circle {
      width: 45px !important;
      height: 45px !important;
    }
  }
}
/*
*圆形进度条样式
*修改rightcircle，leftcircle的角度改变进度条 45deg-225deg
*/
.circleProgress_wrapper {
  position: relative;
  width: 34px;
  height: 34px;
  margin-right: 5px;
  text-align: center;
  line-height: 34px;
  color: #ff7200;
  .wrapper {
    width: 17px;
    height: 34px;
    position: absolute;
    top: 0;
    overflow: hidden;
  }
  .right {
    right: 0;
  }
  .left {
    left: 0;
  }
  .circleProgress {
    width: 34px;
    height: 34px;
    border: 3px solid #20a8d8;
    border-radius: 50%;
    position: absolute;
    top: 0;
    transform: rotate(45deg);
  }
  .rightcircle {
    border-top: 3px solid #9fccdc;
    border-right: 3px solid #9fccdc;
    right: 0;
  }
  .leftcircle {
    border-bottom: 3px solid#9fccdc;
    border-left: 3px solid#9fccdc;
    left: 0;
  }
}

.squareProgress_wrapper {
  position: relative;
  width: 82px;
  height: 12px;
  background-color: #ccc;
  .squareProgress--inner {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #20a8d8;
  }
}

// .setting {
//   display: block;
//   width: 20px;
//   height: 20px;
//   margin: 0 auto;
//   background-color: green;
//   cursor: pointer;
// }
// 下拉菜单样式
// .xf-btn{
//   color:#20a8d8;
// }
.el-tooltip__popper.is-dark{
  max-width: 500px;
}
</style>
